import { marked } from 'marked';

import css from './assets/signoutPopup.css';
import html from './assets/signoutPopup.html';

import { processPopup } from './processPopup';

const imageUrl =
    'https://static.dazndn.com/chapters/web/bootstrap/singnOutFromAllDevices.png';

const replacePlaceholders = (
    html: string,
    texts: { [key: string]: string },
): string =>
    html
        .replace('{{header}}', texts.header)
        .replace('{{body}}', texts.body)
        .replace('{{description}}', marked.parse(texts.description) as string)
        .replace('{{close}}', texts.close)
        .replace('{{image}}', imageUrl);

export const getSignoutPopup = (texts: { [key: string]: string }) =>
    processPopup(replacePlaceholders(html, texts), css);
